import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "qin-form qin-form--auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "qin-form__logo",
  src: "/static/app/quod-logo.png",
  alt: "ls-logo-image"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "qin-form__title" }
const _hoisted_5 = {
  key: 0,
  class: "ds-caption ds-caption--size_3xl ds-caption--bold"
}
const _hoisted_6 = {
  key: 1,
  class: "ds-caption ds-caption--size_3xl ds-caption--bold ds-caption--appearance_center"
}
const _hoisted_7 = {
  key: 0,
  class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey"
}
const _hoisted_8 = { class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey ds-caption--appearance_center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ds-panel ds-panel--space_2xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ds-panel__element ds-panel__element--offset_bottom" })
], -1)
const _hoisted_10 = { class: "qin-form__wrapper" }
const _hoisted_11 = { class: "error-label" }
const _hoisted_12 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_13 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_14 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols g-cols--12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "qin-button qin-button--main qin-button--accent qin-button--full_width qin-button--offset_top-md",
    type: 'submit'
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "qin-button__text" }, /*#__PURE__*/_toDisplayString('Update'))
  ])
], -1)
const _hoisted_16 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_17 = { class: "check-icon-wrapper" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ds-panel ds-panel--space_lg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ds-panel__element ds-panel__element--offset_bottom" })
], -1)
const _hoisted_19 = { class: "g-cell g-cols g-cols--narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_i_check_circle = _resolveComponent("i-check-circle")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.load)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["qin-form__logo-wrapper", {'qin-form__logo-wrapper--centered' : $setup.dataIsSended}])
    }, _hoisted_3, 2),
    _createElementVNode("div", _hoisted_4, [
      (!$setup.dataIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($setup.$t('New Password')), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.$t('Password Updated')), 1))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["qin-form__subtitle", {'centered' : $setup.dataIsSended}])
    }, [
      (!$setup.dataIsSended)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString($setup.$t("Please set a new password here.")), 1))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("p", _hoisted_8, _toDisplayString($setup.$t("Your password has been updated.")), 1),
            _hoisted_9
          ], 64))
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_VeeForm, { onSubmit: $setup.request }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_12, [
            (!$setup.dataIsSended)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_d_control_input, {
                      rules: "required|min:8|max:255",
                      name: "password",
                      type: "password",
                      "input-label": $setup.$t("New Password"),
                      modelValue: $setup.password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event))
                    }, null, 8, ["input-label", "modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_d_control_input, {
                      rules: `required|min:8|max:255|confirmed:${$setup.password}`,
                      name: "password1",
                      type: "password",
                      "input-label": $setup.$t("Confirm Password"),
                      modelValue: $setup.password1,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password1) = $event))
                    }, null, 8, ["rules", "input-label", "modelValue"])
                  ]),
                  _hoisted_15
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_i_check_circle)
                    ]),
                    _hoisted_18
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", {
                      class: "ds-caption ds-caption--color_accent ds-caption--size_sm hovered_underline",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.toAuthForm()), ["prevent"]))
                    }, _toDisplayString($setup.$t('Back to Log In')), 1)
                  ])
                ], 64))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}